import React, { useState } from 'react';
import './index.css';

// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const HorseShoes = (props) => {
    const horseShoesArray = [
        {
            id: "horse1",
            content: <div className="horseshoe1" />
        },
        {
            id: "horse2",
            content: <div className="horseshoe2" />
        },
        {
            id: "horse3",
            content: <div className="horseshoe3" />
        },
        {
            id: "horse4",
            content: <div className="horseshoe4" />
        },
        {
            id: "horse5",
            content: <div className="horseshoe5" />
        },
        {
            id: "horse6",
            content: <div className="horseshoe6" />
        },

    ];

    const [revealClass, setRevealClass] = useState('');

    const [items, setItems] = useState(horseShoesArray);

    // a little function to help us with reordering the result
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        overflow: 'visible',

        // change background colour if dragging


        // styles we need to apply on draggables
        ...draggableStyle,
    });

    const getListStyle = isDraggingOver => ({

        display: 'flex',
        justifyContent: 'space-around',
        overflow: 'visible',
    });
    const testHorseShoes = (result) => {
        var reveal = false;
        if (result && result.length === 6) {
            if (result[0].id === 'horse5' && result[1].id === 'horse2' && result[4].id === 'horse4' && result[5].id === 'horse1') {
                reveal = true;
            }

        }
        return reveal;
    }
    const setRevealBackground = () => {
        setRevealClass('revealBackground');
    }
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const newitems = reorder(
            items,
            result.source.index,
            result.destination.index
        );

        if (testHorseShoes(newitems)) {
            setRevealBackground();
        }
        setItems(newitems)

    }

    return (
        <div className={`horseShoesContainer ${revealClass}`}>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable" direction="horizontal">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                            {...provided.droppableProps}
                        >
                            {items.map((item, index) => (
                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                        >
                                            {item.content}
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
}

export default HorseShoes;